/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EduHatIcon16Solid = forwardRef('EduHatIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.326 1.795a3.125 3.125 0 0 0-2.652 0L.77 4.583a1.306 1.306 0 0 0 .008 2.386l5.913 2.744a3.125 3.125 0 0 0 2.616 0l5.067-2.351v2.856a1.001 1.001 0 1 0 1.25.002V6.688a1.304 1.304 0 0 0-.396-2.105L9.326 1.795Z" }),
        React.createElement("path", { d: "M3 9v2c0 1.082.765 1.847 1.654 2.301.902.461 2.09.699 3.346.699 1.257 0 2.444-.238 3.347-.699C12.235 12.847 13 12.081 13 11V9l-3.692 1.713a3.125 3.125 0 0 1-2.616 0L3 9Z" })));
});
